/* eslint-disable react/jsx-props-no-spreading */
import React, { createContext, useContext, useEffect, useState } from 'react';
import GeneralWebsocket from './GeneralWebsocket';

const GlobalWebsocketContext = createContext(null);

const GlobalWebsocketProvider = (props) => {
	const [generalWebsocket, setGeneralWebsocket] = useState(null);

	useEffect(() => {
		const ws = new GeneralWebsocket({ connect: false });
		setGeneralWebsocket(ws);

		return () => {
			ws.destroy();
		};
	}, []);
	return <GlobalWebsocketContext.Provider value={generalWebsocket} {...props} />;
};

const useGlobalWebsocket = () => {
	const context = useContext(GlobalWebsocketContext);

	return context;
};

export { GlobalWebsocketProvider, useGlobalWebsocket };
